export default class RepositoryError extends Error {
  constructor (err) {
    super(err?.response?.data['hydra:description'] ?? err)
    this.name = 'RepositoryError'
  }
}
